import { BaseAccordionDetails } from '../BaseAccordionDetails/BaseAccordionDetails';
import { AccordionDetailsProps } from './AccordionDetails.types';

/**
 * The Accordion Details wrapper that displays all of the child nodes that get
 * passed to an Accordion Section to display in the expanded section when it is expanded.
 *
 * @param children - {@link AccordionDetailsProps.children children} description.
 */
export const AccordionDetails = ({
    id,
    ariaLabeledBy,
    children,
}: AccordionDetailsProps) => {
    return (
        <BaseAccordionDetails id={id} ariaLabeledBy={ariaLabeledBy}>
            {children}
        </BaseAccordionDetails>
    );
};